import React, {FC} from 'react'
import {BadgeStatus} from '@mdsol/onex-design'
import {JobStatus} from 'graphql-api'

import {CellPropsType} from './cellPropsType'

const JobStatusCell: FC<CellPropsType> = ({cell}) => {
  const status = cell.getValue()

  let type: string | null
  switch(status) {
  case JobStatus.Enqueued:
  case JobStatus.InProgress:
    type = 'information'
    break
  case JobStatus.Completed:
    type = 'success'
    break
  case JobStatus.Failed:
  case JobStatus.FinalError:
    type = 'critical'
    break
  case JobStatus.NotStarted:
  default:
    type = 'neutral'
  }
  const label = status ? status.replaceAll('_', ' ') : ''

  return <BadgeStatus dataTestId='job-status-badge-status' variant={type}>{label}</BadgeStatus>
}

export default JobStatusCell
